import { CssBaseline } from "@material-ui/core";
import MaterialTable from "material-table";
import LabelsContext from "../../../lang/LabelsContext";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import BlacklistService, { BlacklistServiceType } from "./BlacklistService";

export default function Blacklist() {
  const { Labels } = LabelsContext();

  const { blacklist }: BlacklistServiceType = BlacklistService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        icons={tableIcons}
        columns={[
          { field: "firstName", title: Labels.FIRSTNAME },
          { field: "lastName", title: Labels.LASTNAME },
          { field: "emailAddress", title: Labels.EMAIL_ADDRESS },
          { field: "shortReason", title: Labels.SHORT_REASON },
        ]}
        title={Labels.BLACKLIST_AUTHORS}
        data={blacklist}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
        }}
      />
    </>
  );
}
